import { render, staticRenderFns } from "./OrthoBetter.vue?vue&type=template&id=77af952b&scoped=true"
import script from "./OrthoBetter.vue?vue&type=script&lang=js"
export * from "./OrthoBetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77af952b",
  null
  
)

export default component.exports